/**
 * Wyświetla wartość pola na podstawie enuma, lub wszystkie wartości oddzielone znakiem `/`
 *
 * @export
 * @param {string} value
 * @param {any[]} enumList
 * @param {string} [field='text']
 * @returns {string}
 */
export function displayEnum(value: string, enumList: any[], field = 'text'): string {
  const result = enumList.find(enumValue => enumValue.value === value);
  if (result) {
    return result[field];
  }
  return enumList.map(enumValue => enumValue[field]).join('/');
}
